// eslint-disable-next-line
import { h, Component } from 'preact';
import MiniCart from '../MiniCart';
import Request from '../../utils/request';
import { IS_SUBSCRIBED_COOKIE } from './../../consts';
import { getCookie, setCookie } from '../../../../js-utils/cookies';
import { getLocaleParams } from '../../utils';

import styles from './index.scss';

const defaultAppState = {
    isIgnoredPage: false,
    isTradeUpsCart: false,
    expressCheckoutEnabled: false,
    shoppingCartUrl: '',
    tradeUpsImg: '',
    isSubscribedToReminder: false,
    isEcommerceSite: true,
    reminderTimer: 0,
    siteId: '',
    order: {
        numberOfItems: 0,
        numberOfUnavailableItems: 0,
        orderTotalAmount: '',
        isEstimatedTotal: false,
        items: [
            {
                displayName: '',
                truncatedDisplayName: '',
                partNum: '',
                imageURL: '',
                qty: 0,
                listPrice: '',
                salePrice: '',
                isAvailable: true,
                isTradeUpsItem: false,
                partnerPriceName: '',
            },
        ],
    },
    labels: {
        miniCart_title: '',
        ecommerce_keyword_qty: '',
        moreItem: '',
        moreItems: '',
        keyword_Total: '',
        estimatedTotal: '',
        expressCheckout: '',
        standardCheckout: '',
        keyword_Checkout: '',
        miniCart_dontShowReminder: '',
        miniCart_turnOffReminder: '',
        Yes: '',
        No: '',
        partner_price_label: '',
        unavailable: '',
        unavailable_firstUppercase: '',
        tradeUps: '',
        pr_of: '',
        viewShoppingCart: '',
    },
    standardCheckout: {
        successUrl: '',
        errorUrl: '',
    },
    expressCheckout: {
        successUrl: '',
        errorUrl: '',
    },
    user: {
        loggedIn: true,
    },
};

let requestUrl;
let refreshUrl;

const { cc, lc } = getLocaleParams();

switch (process.env.ENV) {
    case 'local': {
        requestUrl = '/cartReminderJson.jsp';
        refreshUrl = '/miniCartJsonHeader.jsp';
        break;
    }
    default: {
        requestUrl = `/shop/${cc}/${lc}/cart/cartReminderJson.jsp`;
        refreshUrl = `/shop/${cc}/${lc}/cart/miniCartJsonHeader.jsp`;
    }
}

class App extends Component {
    state = {
        showMiniCart: false,
        isUnsubscribeClicked: false,
        isUpdateFlagSent: false,
        ...defaultAppState,
    };

    componentDidMount() {
        this.sendInitialRequest(0);

        window.refreshMiniCartItems = this.refreshItemsCount.bind(this);
    }

    /**
     * Sends request to get info about reminder timer
     */
    sendInitialRequest = (reminderTimer = 0) => {
        const requestOpts = { params: {} };

        if (process.env.ENV && process.env.ENV === 'local' && reminderTimer > 0) {
            requestOpts.params.initial = false;
        }

        const request = new Promise(resolve =>
            setTimeout(() => {
                resolve(Request.get(requestUrl, requestOpts));
            }, reminderTimer),
        );

        request
            .then(result => {
                this.setState({
                    ...result,
                });
                return result;
            })
            .then(result => {
                if (result.isSubscribedToReminder) {
                    this.sendRequestForCartItems(result);
                }
            })
            .catch(e => console.error(e));
    };

    /**
     * Sends request to get cart items
     * @param result {Object} - response from server
     * @returns {undefined}
     */
    sendRequestForCartItems = result => {
        const { isIgnoredPage } = this.state;
        let orderResponsePromise;

        if (isIgnoredPage) {
            return null;
        }

        if (result.reminderTimer > 0) {
            this.sendInitialRequest(result.reminderTimer);
        } else {
            orderResponsePromise = Promise.resolve(result);
            this.handleResponseWithCartItems(orderResponsePromise);
        }

        return undefined;
    };

    /**
     *
     * @param orderResponsePromise
     */
    handleResponseWithCartItems = orderResponsePromise => {
        orderResponsePromise
            .then(resultAfterTimer => {
                if (resultAfterTimer.isSubscribedToReminder) {
                    if (getCookie(IS_SUBSCRIBED_COOKIE) === 'false') {
                        if (resultAfterTimer.user.loggedIn) {
                            /* delete cookie */
                            setCookie(IS_SUBSCRIBED_COOKIE, '', {
                                expires: -1,
                                path: '/',
                            });
                        }
                    }

                    if (resultAfterTimer.order) {
                        this.setState(
                            {
                                ...resultAfterTimer,
                            },
                            () => {
                                if (!this.state.isUnsubscribeClicked && getCookie(IS_SUBSCRIBED_COOKIE) !== 'false') {
                                    this.setState({
                                        showMiniCart: true,
                                        isUpdateFlagSent: false,
                                    });
                                }
                            },
                        );
                    } else {
                        this.sendInitialRequest();
                    }
                }
            })
            .catch(e => console.error(e));
    };

    /**
     * Toggles show reminder flag (whether to show reminder or not)
     * @param e - event object
     */
    toggleShowFlag = e => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            showMiniCart: !this.state.showMiniCart,
        });
    };

    /**
     * Closes miniCart and sends notification to server
     */
    closeMiniCart = () => {
        if (!this.state.isUpdateFlagSent) {
            (() =>
                Request.get(requestUrl, { params: { updateReminderTimer: true } })
                    .then(result => {
                        this.setState({
                            ...result,
                            isUpdateFlagSent: true,
                        });
                        return result;
                    })
                    .then(result => {
                        this.sendRequestForCartItems(result);
                    }))();
        }
        this.setState({ showMiniCart: false });
    };

    /**
     * Handle situation, when hide button was clicked
     */
    onHidePromptAction = () => {
        Request.get(requestUrl, { params: { unsubscribe: true } })
            .then(() => {
                setCookie(IS_SUBSCRIBED_COOKIE, 'false', {
                    expires: new Date(Date.now() + 3600 * 24 * 365 * 1000),
                    path: '/',
                });

                if (getCookie(IS_SUBSCRIBED_COOKIE) === 'false') {
                    this.setState({ showMiniCart: false });
                }
            })
            .catch(e => {
                console.error(e);
                setCookie(IS_SUBSCRIBED_COOKIE, 'false', {
                    expires: 0,
                    path: '/',
                });

                if (getCookie(IS_SUBSCRIBED_COOKIE) === 'false') {
                    this.setState({ showMiniCart: false });
                }
            });
    };

    refreshItemsCount() {
        Request.get(refreshUrl, { params: {} })
            .then(data => data.CartCount)
            .then(data => data.cartCount)
            .then(count => {
                const elem = document.querySelector('.js-header-shop[data-count]');
                if (!elem) return;
                elem.setAttribute('data-count', count);
            })
            .catch(err => console.error('Error on refreshing cart items count\r\n', err));
    }

    /**
     * Renders component
     * @returns {*}
     */
    render() {
        if (this.state.order.numberOfItems > 0) {
            return (
                <div className={styles.miniCartOuter}>
                    <MiniCart
                        onClose={this.closeMiniCart}
                        onHidePromptAction={this.onHidePromptAction}
                        {...this.state}
                        sendRequestForCartItems={this.sendRequestForCartItems}
                    />
                </div>
            );
        }

        return null;
    }
}

export default App;
